import { Container, Row, Col, Image } from 'react-bootstrap';
import { FaBriefcase  } from "react-icons/fa";
import styled, { keyframes } from "styled-components";
import { bounceIn } from "react-animations";

import { experience } from '../data/data';

const bounceAnimation = keyframes`${bounceIn}`;

const Heading = styled.h2`
  animation: 1s ${bounceAnimation};
  font-size: 2.5rem;
  font-weight: bold;
  color: #fff;
  margin-top: 5rem;
  margin-bottom:5rem;
`;

const CompanyName = styled.h3`
  color: #2d85e0;
`;


const ProfessionalExperience = () => {
  return (
    <Container className="mt-5">
      <Heading className='text-center' >
        <FaBriefcase className="me-3" />
        Professional Experience
      </Heading>
      {experience.map((exp, index) => (
        <Row key={index} className="mb-5">
          <Col xs={12} md={2} className="d-flex align-items-center justify-content-center">
            <Image src={exp.c_logo} className="w-75" />
          </Col>
          <Col xs={12} md={10}>
            <div className="d-flex justify-content-between">
              <CompanyName>{exp.company_name}</CompanyName>
              <span className="text-muted">{exp.duration}</span>
            </div>
            <p className="fw-bold">{exp.position}</p>
            <ul className='list-unstyled' >
              {exp.key_points.map((point, index) => (
                <li key={index}>
                  <span role="img" aria-label="Rocket" className="me-2">
                    🚀
                  </span>
                  {point}
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      ))}
    </Container>
  );
};

export default ProfessionalExperience;




